module.exports = __webpack_public_path__ + "static/media/ic_thumbnail_default.8a876ca1.png";